import Vue from 'vue'
import VueRouter from 'vue-router'
const activitydetails = () => import( /* webpackChunkName: "member" */ '../views/activitydetails/ActivityDetails.vue')
const articledetails = () => import( /* webpackChunkName: "member" */ '../views/articledetails/ArticleDetails.vue')
const freechargeshare = () => import( /* webpackChunkName: "member" */ '../views/myFreecharge/FreeChargeShare.vue')
const register = () => import( /* webpackChunkName: "member" */ '../views/Register.vue')
const download = () => import( /* webpackChunkName: "member" */ '../views/download/Download.vue')
const about = () => import( /* webpackChunkName: "member" */ '../views/About.vue')
const goodsdetails = () => import( /* webpackChunkName: "member" */ '../views/goodsdetails/GoodsDetails.vue')
const storedetails = () => import( /* webpackChunkName: "member" */ '../views/storedetails/StoreDetails.vue')

Vue.use(VueRouter)

const routes = [{
		path: '/',
		redirect: '/articledetails',
		name: 'articledetails',
		component: articledetails,
	},
	{
		path: '/activitydetails',
		name: 'activitydetails',
		component: activitydetails,
	},
	{
		path: '/articledetails',
		name: 'articledetails',
		component: articledetails,
	},
	{
		path: '/freechargeshare',
		name: 'freechargeshare',
		component: freechargeshare,
	},
	{
		path: '/register',
		name: 'register',
		component: register,
	},
	{
		path: '/download',
		name: 'download',
		component: download,
	},

	{
		path: '/about',
		name: 'about',
		component: about,
	},
	{
		path: '/goodsdetails',
		name: 'goodsdetails',
		component: goodsdetails,
	},
	{
		path: '/storedetails',
		name: 'storedetails',
		component: storedetails,
	},


]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default router
